import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationExtras, Route } from '@angular/router';
import { TokenStorageService } from './token-storage.service';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard  {

  constructor(private tokenStorageService: TokenStorageService,
              private router: Router,
              private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = this.tokenStorageService.getToken();
    if (token === undefined || token === null || token === '') {
      this.tokenStorageService.clearSessionStorage();
      this.authService.redirectUrl = state.url;
      this.router.navigateByUrl('/login');
      return false;
    }
    const hasPermission = this.authService.hasPermission(state.url);
    if (!hasPermission) {
      this.router.navigateByUrl(`/error/access-denied`, { skipLocationChange: true });
    }
    return hasPermission;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    return true;
  }
}
